import i18n from "@/plugins/i18n";
import store from "../store/index";

const cardimg0 = "/images/card_imgs/00.png";
const cardimg1 = "/images/card_imgs/01.png";
const cardimg2 = "/images/card_imgs/02.png";
const cardimg3 = "/images/card_imgs/03.png";
const cardimg4 = "/images/card_imgs/04.png";
const cardimg5 = "/images/card_imgs/05.png";
const cardimg6 = "/images/card_imgs/06.png";
const cardimg7 = "/images/card_imgs/07.png";
const cardimg8 = "/images/card_imgs/08.png";
/* const import = "/images/card_imgs/09.png"; */
const cardimg10 = "/images/card_imgs/10.png";
const cardimg11 = "/images/card_imgs/11.png";
const cardimg12 = "/images/card_imgs/12.png";
const cardimg13 = "/images/card_imgs/13.png";

let steps = [
    {
        imageSrc: cardimg0,
        tooltip: i18n.t('dashboard.steps.step0.tooltip'),
        title: i18n.t('dashboard.steps.step0.title'),
        message: i18n.t('stepValidations.step1'),
        route_link: "/company",
        completed: false,
        step_number: 1,
        upNext: false,
        skippable: false,
    },
    {
        imageSrc: cardimg1,
        tooltip: i18n.t('dashboard.steps.step1.tooltip'),
        title: i18n.t('dashboard.steps.step1.title'),
        message: i18n.t('stepValidations.step2'),
        route_link: "/stakeholders",
        completed: false,
        step_number: 2,
        upNext: false,
        skippable: true,
    },
    {
        imageSrc: cardimg2,
        tooltip: i18n.t('dashboard.steps.step2.tooltip'),
        title: i18n.t('dashboard.steps.step2.title'),

        route_link: "/sdg-alignment-surveys",
        completed: false,
        step_number: 3,
        upNext: false,
        skippable: true,
    },
    {
        imageSrc: cardimg3,
        tooltip: i18n.t('dashboard.steps.step3.tooltip'),
        title: i18n.t('dashboard.steps.step3.title'),

        route_link: "/sdg-alignment-surveys",
        completed: false,
        step_number: 4,
        upNext: false,
        skippable: true,
    },
    {
        imageSrc: cardimg4,
        tooltip: i18n.t('dashboard.steps.step4.tooltip'),
        title: i18n.t('dashboard.steps.step4.title'),
        message: i18n.t('stepValidations.step5'),
        route_link: "/stakeholders",
        completed: false,
        step_number: 5,
        upNext: false,
        skippable: true,
    },
    {
        imageSrc: cardimg5,
        tooltip: i18n.t('dashboard.steps.step5.tooltip'),
        title: i18n.t('dashboard.steps.step5.title'),

        route_link: "/materiality-analysis-surveys",
        completed: false,
        step_number: 6,
        upNext: false,
        skippable: true,
    },
    {
        imageSrc: cardimg6,
        tooltip: i18n.t('dashboard.steps.step6.tooltip'),
        title: i18n.t('dashboard.steps.step6.title'),

        route_link: "/materiality-analysis-surveys",
        completed: false,
        step_number: 7,
        upNext: false,
        skippable: true,
    },
    {
        imageSrc: cardimg7,
        tooltip: i18n.t('dashboard.steps.step7.tooltip'),
        title: i18n.t('dashboard.steps.step7.title'),

        route_link: "/materiality-analysis-surveys",
        completed: false,
        step_number: 8,
        upNext: false,
        skippable: true,
    },
    {
        imageSrc: cardimg8,
        tooltip: i18n.t('dashboard.steps.step8.tooltip'),
        title: i18n.t('dashboard.steps.step8.title'),
        message: i18n.t('stepValidations.step9'),
        route_link: "/su2Results",
        completed: false,
        step_number: 9,
        upNext: false,
        skippable: true,
    },
    /* {
      imageSrc: cardimg9,
      tooltip: i18n.t('dashboard.steps.step9.tooltip'),
      title: i18n.t('dashboard.steps.step9.title'),

      route_link: "/reports",
      completed: false,
      step_number: 10,
      upNext: false,
      skippable: true,
    }, */ /* add it back when step is integrated to the system */
    {
        imageSrc: cardimg10,
        tooltip: i18n.t('dashboard.steps.step10.tooltip'),
        title: i18n.t('dashboard.steps.step10.title'),
        long_text: true,
        route_link: "/reports",
        completed: false,
        step_number: 10,
        upNext: false,
        skippable: true,
        is_disabled: true // Disabled it because we want to make strategy reports mandatory
    },
    {
        imageSrc: cardimg11,
        tooltip: i18n.t('dashboard.steps.step11.tooltip'),
        title: i18n.t('dashboard.steps.step11.title'),
        message: i18n.t('stepValidations.step11'),
        route_link: "/kpi-metrics",
        completed: false,
        step_number: 11,
        upNext: false,
        skippable: false,
    },
    {
        imageSrc: cardimg12,
        tooltip: i18n.t('dashboard.steps.step12.tooltip'),
        title: i18n.t('dashboard.steps.step12.title'),

        route_link: "/generate-sections",
        completed: false,
        step_number: 12,
        upNext: false,
        skippable: false,
    },
    {
        imageSrc: cardimg13,
        tooltip: i18n.t('dashboard.steps.step13.tooltip'),
        title: i18n.t('dashboard.steps.step13.title'),

        route_link: "/reports",
        completed: false,
        step_number: 13,
        upNext: false,
        skippable: false,
    },
];

function setupSteps() {
    const user = store.state.app.user;
    if (!user) {
        console.error('Error occurred while accessing the user!');
        return;
    }

    const params = {
        company_id: user.company_id,
        is_deleted: false,
    };

    store.dispatch('settings/getProcessTrack', params)
        .then(res => {
            store.dispatch('settings/setProcessTrackId', res.data[0].reporting_process_track_id);

            steps[0].completed = res.data[0].is_step_1_completed;
            steps[1].completed = res.data[0].is_step_2_completed;
            steps[2].completed = res.data[0].is_step_3_completed;
            steps[3].completed = res.data[0].is_step_4_completed;
            steps[4].completed = res.data[0].is_step_5_completed;
            steps[5].completed = res.data[0].is_step_6_completed;
            steps[6].completed = res.data[0].is_step_7_completed;
            steps[7].completed = res.data[0].is_step_8_completed;
            steps[8].completed = res.data[0].is_step_9_completed;
            /* steps[9].completed  = res.data[0].is_step_10_completed; */ /* add it back when step is integrated to the system */
            steps[9].completed = res.data[0].is_step_10_completed;
            steps[10].completed = res.data[0].is_step_11_completed;
            steps[11].completed = res.data[0].is_step_12_completed;
            steps[12].completed = res.data[0].is_step_13_completed;

            store.dispatch('company/checkReportsPublished')
                .then(res => {
                    if (res.data.published === false) {
                        for (let i = 1; i < 10; ++i) {
                            steps[i].skippable = false;
                        }
                    } else {
                        for (let i = 1; i < 10; ++i) {
                            steps[i].skippable = true;
                        }
                    }

                    store.dispatch('settings/setProcessSteps', steps);
                })
        })
}

export {
    steps,
    setupSteps,
};